import Loadable from '../../components/loadable';

const PosProductList = Loadable({
  loader: () => import('../../pages/pos/products/list'),
  type: 'block',
});

angular.module('gym').value('PosProductList', PosProductList);

const PosProductListFiltersModal = Loadable({
  loader: () => import('../../pages/pos/products/list/pos_product_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('PosProductListFiltersModal', PosProductListFiltersModal);
